import React from 'react';

import IMG_NHS from 'assets/tags/discount.svg';
import PlanBenefitsSplashPanel from 'components/hr/timeOffSplash/TimeOffSplashPlanBenefitsPanel.component';
import ClientTagsSplashVideoContainer from 'components/tags/splash/ClientTagsSplashVideo.component';

import CN from './ClientTagsSplashBottomPanel.module.scss';

const ClientTagsSplashBottomPanel = () => (
  <section data-bem="ClientTagsSplashBottomPanel" className={CN.component}>
    <ClientTagsSplashVideoContainer />
    <div data-bem="ClientTagsSplashBottomPanel__benefits" className={CN.cardBenefits}>
      <PlanBenefitsSplashPanel showTrialButton />
    </div>
    <img
      data-bem="ClientTagsSplashBottomPanel__nhs-mobile"
      src={IMG_NHS}
      className={CN.imgNHSMobile}
      alt="Graphics map discount icon"
    />
    <span className={CN.blur1} data-bem="ClientTagsSplashBottomPanel__blur-1" />
    <span className={CN.blur2} data-bem="ClientTagsSplashBottomPanel__blur-2" />
  </section>
);

// noinspection JSUnusedGlobalSymbols
export default ClientTagsSplashBottomPanel;
